module.exports = __webpack_public_path__ + "static/media/blog.4dfa259e.jpg";